import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationModel } from 'projects/phdsoft/common/src/lib/models/notification.model';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  private hubConnection: signalR.HubConnection;
  public notificationCounter: number
  public notifications: NotificationModel[] = []
  public lastNotification: NotificationModel

  // Emits every notification as it arrives so components (e.g. screens outside the
  // digital-twin viewer that don't render the notifications toolbar) can surface them.
  public notification$ = new Subject<NotificationModel>()

  constructor() { }

  async addToGroup(userId) {
    await this.hubConnection.invoke('AddToGroup', userId);
  }

  public addNotificationModel(notification: NotificationModel) {
    let date = new Date()
    notification.dateTime = date.getHours().toString().padStart(2, "0") + ':' + date.getMinutes().toString().padStart(2, "0") + ':' + date.getSeconds().toString().padStart(2, "0")

    this.notificationCounter++
    this.notifications.unshift(notification)
    this.lastNotification = notification
    console.log('🔔 [NotificationService] addNotificationModel →', notification?.title, '|', notification?.message)
    this.notification$.next(notification)
  }

  public addNotification(title?: string, message?: string, fileUrl?: string) {
    var notification: NotificationModel = {}

    if (title) notification.title = title
    if (message) notification.message = message
    if (fileUrl) notification.fileUrl = fileUrl

    this.addNotificationModel(notification)
  }

  public addFinishedNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'has Finished'
    }
    this.addNotificationModel(notification)
  }

  public addLoadedNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'Loaded'
    }
    this.addNotificationModel(notification)
  }

  public addInProgressNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'In Progress'
    }
    this.addNotificationModel(notification)
  }

  public addSuccessNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'Success'
    }
    this.addNotificationModel(notification)
  }

  public addFailedNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'Failed'
    }
    this.addNotificationModel(notification)
  }

  public addSettedUpNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'Setted Up'
    }
    this.addNotificationModel(notification)
  }

  public addUpdatedNotification(_title: string) {
    var notification: NotificationModel = {
      title: _title,
      message: 'Updated'
    }
    this.addNotificationModel(notification)
  }

  public addGettingNotification(message: string) {
    var notification: NotificationModel = {
      title: 'Getting',
      message: message
    }
    this.addNotificationModel(notification)
  }

  public addGeneratingNotification(message: string) {
    var notification: NotificationModel = {
      title: 'Generating',
      message: message
    }
    this.addNotificationModel(notification)
  }

  public addErrorNotification(message: string) {
    var notification: NotificationModel = {
      title: 'Error',
      message: message
    }
    this.addNotificationModel(notification)
  }
}
